/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FaAlignJustify } from 'react-icons/fa';

import SorttableElement from './SortableElement';

const SortableList = ({ categories, onDragEnd }) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="droppable" type="CATEGORIES" direction="horizontal">
      {(provided, snapshot) => (
        <DroppableElement
          ref={provided.innerRef}
          isDragging={snapshot.isDraggingOver}
        >
          {categories.map((category, index) => (
            <Draggable
              key={category.id}
              draggableId={category.id}
              index={index}
            >
              {(provided, snapshot) => (
                <Element
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  isDragging={snapshot.isDragging}
                  style={provided.draggableProps.style}
                >
                  <Title>
                    <span {...provided.dragHandleProps}>
                      <FaAlignJustify />
                    </span>
                    <CategoryText>
                      {`${category.displayName} (${category.Products.length})`}
                    </CategoryText>
                  </Title>
                  <SorttableElement questionNum={index} question={category} />
                </Element>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </DroppableElement>
      )}
    </Droppable>
  </DragDropContext>
);

const DroppableElement = styled.div`
  background: ${(props) => (props.isDragging ? 'lightblue' : '#ece9e9')};
  width: 100%;
  display: flex;
  border: 1px solid rgba(0,0,0,0.3);
  user-select: none;
`;

const Element = styled.div`
  list-style-type: none;
  background: ${(props) => (props.isDragging ? 'green' : 'white')};
  color: ${(props) => (props.isDragging ? '#fff' : '#333')} !important;
  border: 1px solid rgba(0,0,0,0.3);
  width: 100%;
  margin: 0 !important;
  flex: 1;
  text-align: center;
`;

const Title = styled.p`
  border-bottom: 1px solid rgba(0,0,0,0.3);
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  width: 100%;
  margin: 0 !important;
  padding: 6px !important;
`;

const CategoryText = styled.p`
  width: 100%;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  font-weight: bold;
  margin: 0 !important;
  padding: 0 !important;
`;

SortableList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    displayName: PropTypes.string,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        displayName: PropTypes.string,
      }),
    ),
  })).isRequired,
  onDragEnd: PropTypes.func.isRequired,
};

export default SortableList;
